import { injectReducer } from '../../store/reducers';
import { injectSagas } from '../../store/sagas';

export default store => ({
  path : '/admin/conferences/create',
  getComponent(nextState, cb) {
    require.ensure([], (require) => {
      const Counter = require('./containers/AddConferenceContainer').default;
      const reducer = require('reducers/newConference').default;
      const sagas = require('sagas/sagas').default;

      injectReducer(store, { key: 'newConference', reducer });
      injectSagas(store, { key: 'sagas', sagas });

      cb(null, Counter);
    }, 'addconference');
  },
});



// WEBPACK FOOTER //
// /Users/balazskaxd/dev/rkk/rkk-webapp/src/routes/AddConference/index.js